import React,{useEffect,useState} from 'react'
import Background from './background'
import TimelineData from './TimelineData'
import TimelineItems from './TimelineItems'
import "../styles/timeline.css";
// import { css } from "@emotion/react";
// import PacmanLoader	 from "react-spinners/PacmanLoader";

// const override = css`
//   display: block;
//   margin: 0 auto;
//   border-color: black;
//   margin-top:21rem;
// `;


function Timeline() {
  // let [loading, setLoading] = useState(true);

  // useEffect(()=>{
  //   setTimeout(()=>{
  //       setLoading(false);
  //   },1200)
  // })
  return (<div style={{width:"100%"}}>
      
    {/* <div  className='background'> */}
       {/* <Background/> */}
                   
       <div className='heading timeline__heading'>
        <h3>
        Timeline
        </h3>
        {/* <a href="/" style={{position:'fixed'}}>
          Go Back
        </a> */}

        </div>

        <div className='wrapper'>
         <div className="timeline" id="Features">
        {TimelineData.map((item, index) => {
          return (
            <TimelineItems key={index} title={item.heading} date={item.date} link={item.link} origin={item.origin} originColor={item.originColor} conversionText={item.conversionText}/>
            )
          })
        }
        </div>
    </div>
   
    {/* </div> */}
  
  </div>
  )
}

export default Timeline;
